type IconProps = {
  className?: string;
};

const VoiceMailIcon = ({ className, ...rest }: IconProps) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className || "w-[18px] h-[19px]"}
    {...rest}
  >
    <g clipPath="url(#clip0_10118_282914)">
      <path
        d="M9 2.45996C4.86499 2.45996 1.5 5.82495 1.5 9.95996C1.5 14.0949 4.86499 17.46 9 17.46C13.135 17.46 16.5 14.0949 16.5 9.95996C16.5 5.82495 13.135 2.45996 9 2.45996ZM11.875 12.0049H6.125C5 12.0049 4.07998 11.09 4.07998 9.95996C4.07998 8.82996 5 7.91495 6.125 7.91495C7.255 7.91495 8.17499 8.82996 8.17499 9.95996C8.17499 10.3449 8.06 10.7 7.875 11.0049H10.125C9.94 10.7 9.82501 10.3449 9.82501 9.95996C9.82501 8.82996 10.745 7.91495 11.875 7.91495C13 7.91495 13.92 8.82996 13.92 9.95996C13.92 11.09 13 12.0049 11.875 12.0049Z"
        fill="currentColor"
      />
      <path
        d="M11.8742 8.91504C11.2942 8.91504 10.8242 9.38504 10.8242 9.96005C10.8242 10.535 11.2942 11.005 11.8742 11.005C12.4492 11.005 12.9192 10.535 12.9192 9.96005C12.9192 9.38504 12.4492 8.91504 11.8742 8.91504Z"
        fill="currentColor"
      />
      <path
        d="M6.12509 8.91504C5.55008 8.91504 5.08008 9.38504 5.08008 9.96005C5.08008 10.535 5.55008 11.005 6.12509 11.005C6.70508 11.005 7.17508 10.535 7.17508 9.96005C7.17508 9.38504 6.70508 8.91504 6.12509 8.91504Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_10118_282914">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(1 1.95996)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default VoiceMailIcon;
